export default __webpack_public_path__ + "static/media/1963.4a6eb8de.jpg";